import { render, staticRenderFns } from "./addDataTrend.vue?vue&type=template&id=383df03a&scoped=true"
import script from "./addDataTrend.vue?vue&type=script&lang=js"
export * from "./addDataTrend.vue?vue&type=script&lang=js"
import style0 from "./addDataTrend.vue?vue&type=style&index=0&id=383df03a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383df03a",
  null
  
)

export default component.exports